import CaseList from "@/features/legal/components/CaseList";
import Infoboxes from "@/features/legal/components/Infoboxes";
import ContentLoading from "@/components/ContentLoading";
import { usePaginatedLegalCasesQuery } from "@/hooks/useLegal";
import { Transition, TransitionChild } from "@headlessui/react";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { z } from "zod";

const DEFAULT_PAGE = 1;
const DEFAULT_PER_PAGE = 20;

const schema = z.object({
  page: z.number().optional().catch(DEFAULT_PAGE),
  per_page: z.number().optional().catch(DEFAULT_PER_PAGE),
  q: z.string().optional(),
  sort: z.string().optional(),
  dmf: z.union([z.literal(0), z.literal(1)]).optional(),
  status: z.string().optional(),
});

export const Route = createFileRoute("/_protected/_legal/legal/")({
  head: () => ({
    meta: [{ title: "Legal" }],
  }),
  validateSearch: schema,
  component: LegalComponent,
});

function LegalComponent() {
  const { data, isPending, isFetching } = usePaginatedLegalCasesQuery();
  const navigate = useNavigate({ from: Route.fullPath });

  if (!data) {
    return <ContentLoading />;
  }

  return (
    <Transition
      appear
      show={!!data}
      as="div"
      className="transition duration-1000 data-[closed]:opacity-0 md:h-full max-md:bg-white flex flex-col"
    >
      <Infoboxes />
      <TransitionChild>
        <div className="md:p-8 p-4 md:pt-0 relative transition duration-500 data-[closed]:translate-y-24">
          <CaseList
            data={data}
            isLoading={isPending || isFetching}
            onSearch={(value) =>
              navigate({
                search: (prev) => ({
                  ...prev,
                  q: value,
                  page: DEFAULT_PAGE,
                }),
              })
            }
            onSortChange={(value) =>
              navigate({
                search: (prev) => ({
                  ...prev,
                  sort: value,
                  page: DEFAULT_PAGE,
                }),
              })
            }
            onDmfChange={(value) =>
              navigate({
                search: (prev) => ({
                  ...prev,
                  dmf: value,
                  page: DEFAULT_PAGE,
                }),
              })
            }
            onStatusChange={(value) =>
              navigate({
                search: (prev) => ({
                  ...prev,
                  status: value,
                  page: DEFAULT_PAGE,
                }),
              })
            }
          />
        </div>
      </TransitionChild>
    </Transition>
  );
}
